import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  type: null,
  props: {},
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openAgentPro(state, action) {
      state.type = 'agentPro';
      state.props = action.payload || {};
    },

    openAgentProStartFreeTrial(state, action) {
      state.type = 'agentProStartFreeTrial';
      state.props = action.payload || {};
    },

    openPaymentStatus(state, action) {
      state.type = 'paymentStatus';
      state.props = action.payload || {};
    },
    closeModal(state) {
      state.type = null;
      state.props = {};
    },
  },
});

export const modalActions = modalSlice.actions;
export default modalSlice.reducer;
